import {
  ErrorHandler as AngularErrorHandler,
  Injectable,
  inject,
} from '@angular/core';
import { ErrorService } from './error.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandler implements AngularErrorHandler {
  private errorService = inject(ErrorService);

  handleError(error: unknown): void {
    this.errorService.handleError(error);
  }
}
